import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

interface LayoutProps {
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ onLogout }) => {
  const [isSidebarMinimized, setSidebarMinimized] = useState(true);

  const toggleSidebar = () => {
    setSidebarMinimized(!isSidebarMinimized);
  };

  return (
    <div style={{ display: 'flex', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#f1f5f9', minHeight: '100vh' }}>
      <Sidebar isMinimized={isSidebarMinimized} toggleSidebar={toggleSidebar} onLogout={onLogout} />
      <main style={{ flexGrow: 1, marginLeft: '80px', overflowY: 'auto' as 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
